// sharing
export const TITLE = 'The 2021 Lemonade Giveback';
export const SHARING_EVENT = 'giveback2021.share.clicked';
export const SHARING_URL = 'https://bit.ly/3ydlcXU';
export const SHARING_CONTENT =
  'This is huge. Thanks to the Lemonade community, 65 nonprofits will be receiving donations via Giveback 2021! Get all the numbers and see the full impact here: #GoLemonade #Giveback2021 via @lemonade_inc';

// scroll
export const BASE_HEIGHT = 80000;
export const ACTUAL_HEIGHT = 70000;
export const SCROLL_RATIO = BASE_HEIGHT / ACTUAL_HEIGHT;
